// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"4904":"b3528480","9258":"bcb5ee45"}[chunkId] || chunkId) + "." + {"2013":"44ecd69a69e0c131","4904":"e9c51fd738d24508","6796":"806fdc001fedd51b","9258":"8db7bd436bb5b0fa"}[chunkId] + ".js";
};